#import "./SearchIndexFull.graphql"
#import "./AttachmentFull.graphql"
#import "./TimestampsFull.graphql"

fragment CareerApplicationFull on CareerApplication {
  id
  name
  surname
  position
  state
  phone
  email
  curriculumVitae {
    ...AttachmentFull
  }
  locale
  message
  fromUrl
  ...SearchIndexFull
  ...TimestampsFull
}
